import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReportQueryService } from '../../shared/services/report-query.service';
import {
  GetAllReportsRequest,
  HCReport,
} from '../../shared/interfaces/report-query.model';
import { MatButton } from '@angular/material/button';
import { TwDatePipe } from '../../pipes/tw-date.pipe';
import { NgOptimizedImage } from '@angular/common';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
/**
 * 會員中心查詢檢查報告組件
 */
@Component({
  selector: 'app-report-query',
  standalone: true,
  imports: [
    TranslatePipe,
    MatButton,
    TwDatePipe,
    NgOptimizedImage,
    NgxPaginationModule,
  ],
  templateUrl: './report-query.component.html',
  styleUrl: './report-query.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ReportQueryComponent implements OnInit {
  translateService: TranslateService = inject(TranslateService);
  reportQueryService: ReportQueryService = inject(ReportQueryService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  reportList: Array<HCReport> = []; // 檢查報告清單
  toastr: ToastrService = inject(ToastrService);

  // 分頁設定
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = false;
  public config: PaginationInstance = {
    id: 'report-pagination',
    itemsPerPage: 4,
    currentPage: 1,
  };
  public labels: {
    previousLabel: string;
    nextLabel: string;
  } = {
    previousLabel: '',
    nextLabel: '',
  };

  ngOnInit(): void {
  // 從 SharedStorage 取得登入用戶資訊
  const idNo =
    this.sharedStorageService.get('idLoginRequest')?.idNo ??
    this.sharedStorageService.get('createMemberRequest')?.idNo ??
    '';

  if (!idNo) {
    console.error('無法從 SharedStorage 取得用戶 idNo');
    this.toastr.error('無法取得用戶資訊');
    return;
  }

  console.log('從 SharedStorage 取得的 idNo:', idNo);

  const request: GetAllReportsRequest = {
    idNo: idNo,
    range: '5', //查詢最近 5 年的報告
  };

  this.reportQueryService.getAllReports(request)
    .then(res => {
      this.reportList = res.data?.hcreportList ?? [];
    })
  }

  // 下載報告
  downloadReport(caseNo: string | undefined) {
    if (caseNo) {
      this.reportQueryService.downloadReport(caseNo)
        .then(() => {
          this.toastr.success(
            this.translateService.instant('report-query.report-success')
          );
        })
        .catch((error) => {
          this.toastr.error('檔案下載失敗');
          console.error('下載報告失敗:', error);
        });
    }
  }

  // 分頁事件處理
  onPageChange(number: number) {
    this.config.currentPage = number;
  }

  onPageBoundsCorrection(number: number) {
    this.config.currentPage = number;
  }
}
